import { Vault } from "@/modules/vault";
import { createFileRoute } from "@tanstack/react-router";
import CustomNotFound from "@/modules/notFound";

export const Route = createFileRoute("/dashboard")({
  component: Vault,
  notFoundComponent: CustomNotFound,
});